module.exports = __webpack_public_path__ + "static/img/bank@2x.43a24d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbPlatformInfoMin/bank@2x.png
// module id = QQrf
// module chunks = 69